import { TopMenuItem } from "../common/models/top-menu-item.model";


export class TopMenu{
    TopMenuItems: Array<TopMenuItem> 
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/menus/topmenu.ts